type CqrmErrorFallbackProps = {
  error: Error;
};

export function CqrmErrorFallback({ error }: CqrmErrorFallbackProps) {
  return (
    <main style={{ fontFamily: "system-ui, sans-serif", margin: "2rem", maxWidth: "40rem" }}>
      <h1 style={{ marginTop: 0 }}>Something went wrong</h1>
      <p role="alert" style={{ color: "#b00020" }}>
        {error.message}
      </p>
      <p style={{ color: "#555" }}>
        The error was reported to Sentry. Reload the page or sign in again if the problem persists.
      </p>
    </main>
  );
}
